import { useEffect, useState } from "react"
import { CircularProgress, Grid, Modal, ObjectiveCard, Typography } from "src/lib"
import { useOpportunitiesStore } from "src/store/opportunitiesStore"
import { OpportunitiesState } from "src/store/opportunitiesStore/types"
import { IRelatedOpportunitiesModalProps } from "./types"

const RelatedOpportunitiesModal = ({ client, open, ...props }: IRelatedOpportunitiesModalProps) => {
    const [loading, setLoading] = useState<boolean>(false)
    const [relatedOpportunities, setRelatedOpportunities] = useState<any[]>([])
    const opportunitiesData = useOpportunitiesStore((s: OpportunitiesState) => s.opportunitiesData)

    const formatAddedAt = (createdDate: string) => {
        const date = new Date(createdDate)
        if (Number.isNaN(date.getTime())) {
            return createdDate
        }
        return date.toLocaleDateString("pt-BR")
    }

    const formatDueDate = (daysOfValid: number) => {
        return `${daysOfValid} dias`
    }

    useEffect(() => {
        const searchRelatedOpportunities = async () => {
            if (!client || !open) {
                setRelatedOpportunities([])
                return
            }

            // Verifica se o client tem as propriedades necessárias
            if (!client.name || client.account === undefined) {
                console.warn("Client payload inválido:", client)
                setRelatedOpportunities([])
                return
            }

            try {
                setLoading(true)

                // Simula um delay para mostrar o loading durante a busca
                await new Promise(resolve => setTimeout(resolve, 500))

                // Busca as oportunidades relacionadas ao cliente no store
                if (opportunitiesData?.objectives) {
                    const filtered = opportunitiesData.objectives.filter((opportunity) => {
                        return opportunity.impacted_clients?.some(
                            (impactedClient) =>
                                impactedClient?.p?.name === client.name &&
                                String(impactedClient?.p?.account ?? "") === String(client.account ?? "")
                        )
                    })
                    setRelatedOpportunities(filtered)
                } else {
                    setRelatedOpportunities([])
                }
            } catch (error) {
                console.error("Erro ao buscar oportunidades relacionadas:", error)
                setRelatedOpportunities([])
            } finally {
                setLoading(false)
            }
        }

        searchRelatedOpportunities()
    }, [client, open, opportunitiesData])

    if (!client) {
        return null
    }

    return (
        <Modal
            {...props}
            onClickAIButton={() => { }}
            open={open}
            title="Oportunidades Relacionadas ao Cliente"
        >

            <Grid
                container
                spacing={2}
                gap={2}
                sx={{
                    mt: 2,
                    maxHeight: '60vh',
                    overflowY: 'auto',
                    alignContent: 'flex-start',
                    padding: 2
                }}
                alignItems="stretch"
            >
                {loading ? (
                    <Grid container justifyContent="center" sx={{ py: 4 }}>
                        <CircularProgress color="primary" />
                    </Grid>
                ) : relatedOpportunities.length === 0 ? (
                    <Typography variant="body2" color="secondary">
                        Nenhuma oportunidade encontrada para este cliente.
                    </Typography>
                ) : (
                    relatedOpportunities.map((objective) => (
                        <ObjectiveCard
                            key={`${objective.title}  ${objective.createdDate}`}
                            title={objective.title}
                            objectiveId={objective.objective_id}
                            recommendation={objective.text}
                            addedAt={formatAddedAt(objective.createdDate)}
                            dueDate={formatDueDate(objective.daysOfValid)}
                            impactedClients={String(objective.impacted_clients?.length ?? 0)}
                            impactedClientsArray={objective.impacted_clients}
                            context={objective.title}
                        />
                    ))
                )}
            </Grid>
        </Modal>
    )
}

export { RelatedOpportunitiesModal }